type ExclusiveValues<U1, U2> = Exclude<U1, U2> | Exclude<U2, U1>;
type EnumValues<T> = T extends string ? `${T}` : never;
type CompatibleUnions<U1, U2> = ExclusiveValues<U1, U2> extends never ? U1 : never;
type CompatibleEnums<E1, E2> = CompatibleUnions<EnumValues<E1>, EnumValues<E2>> extends never ? never : E1;

/**
 * This does nothing under the hood except validates in TS that the enum conversion is correctly typed.
 *
 * @param fromValue - The value
 * @returns - The target enum
 */
export function safelyConvertEnum<To extends string, From extends string = EnumValues<To>>(
    fromValue: CompatibleEnums<From, To>,
): To {
    return fromValue as unknown as To;
}
